import React from "react";
import { BRAND } from "../lib/brand";

const WhatsAppFloat = () => {
  return (
    <a
      data-testid="whatsapp-float"
      href={BRAND.whatsapp}
      target="_blank"
      rel="noreferrer noopener"
      aria-label="WhatsApp"
      className="fixed bottom-24 right-6 z-40 w-14 h-14 rounded-full flex items-center justify-center bg-[#25D366] text-white hover:scale-110 transition-transform shadow-lg"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M20.52 3.48A11.86 11.86 0 0 0 12.05 0C5.5 0 .18 5.32.17 11.87c0 2.09.55 4.13 1.6 5.93L0 24l6.34-1.66a11.86 11.86 0 0 0 5.7 1.45h.01c6.55 0 11.87-5.32 11.88-11.87a11.8 11.8 0 0 0-3.41-8.44ZM12.05 21.8h-.01a9.94 9.94 0 0 1-5.06-1.39l-.36-.21-3.76.99 1-3.66-.24-.38a9.85 9.85 0 0 1-1.51-5.28c0-5.45 4.44-9.88 9.94-9.88a9.86 9.86 0 0 1 7.02 2.91 9.83 9.83 0 0 1 2.9 7 9.9 9.9 0 0 1-9.92 9.9Zm5.44-7.4c-.3-.15-1.77-.87-2.05-.97-.28-.1-.48-.15-.68.15s-.78.97-.96 1.17c-.18.2-.35.23-.65.08-.3-.15-1.27-.47-2.42-1.5a9.11 9.11 0 0 1-1.68-2.08c-.18-.3-.02-.46.13-.61.14-.14.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.08-.15-.68-1.62-.92-2.22-.24-.58-.49-.5-.68-.51-.18-.01-.38-.01-.58-.01-.2 0-.53.08-.8.38-.28.3-1.05 1.03-1.05 2.5 0 1.47 1.07 2.9 1.22 3.1.15.2 2.1 3.2 5.1 4.49.71.31 1.27.5 1.71.63.72.23 1.37.2 1.89.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.08-.13-.28-.2-.58-.35Z" />
      </svg>
    </a>
  );
};

export default WhatsAppFloat;
